import { useState, createContext,  useContext } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const [auth, setAuth] = useState({
    token: localStorage.getItem("AUTH_TOKEN"),
    status: localStorage.getItem("AUTH_TOKEN") ? true : false,
  });

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { useAuth, AuthProvider };